module.exports = __webpack_public_path__ + "img/kr-product-card2-bg.b663802.png";